export const CLEAR_STORE = 'CLEAR_STORE'